export const allTaxonomyConcepts = groq`
*[_type == "skosConceptScheme" && slug.current == $slug ][0]{
  topConcepts[]->{
     prefLabel,
    _id,
    slug,
    "children": *[_type == "skosConcept" && references(^._id)]{
      _id,
      prefLabel,
      slug,
      "children": *[_type == "skosConcept" && references(^._id)]{
        _id,
        prefLabel,
        slug,
      } | order(prefLabel asc)
    } | order(prefLabel asc)
  }
}.topConcepts
`;
